// The JSON data viewer is a dev-only diagnostic tool - never show it in a
// production deployment, even if someone flips the feature flag on.
export function isJsonViewerEnabled() {
  const isDev = process.env.NODE_ENV === "development";
  const isNotProduction =
    process.env.REACT_APP_ENVIRONMENT !== "PRODUCTION" &&
    process.env.REACT_APP_SERVER !== "PRODUCTION";
  const isLocalhost = window.location.hostname === "localhost";
  const isDevHost =
    window.location.hostname.includes("dev") ||
    window.location.hostname.includes("staging") ||
    window.location.hostname.includes("127.0.0.1");

  return isDev && isNotProduction && (isLocalhost || isDevHost);
}
